import React from "react"
import { Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import Button from "src/components/Button"
import { XFER } from "src/constants"
import { BIG_ZERO } from "src/constants/bigNumber"
import { useUserFerroBoost } from "src/state/xFer/hooks"
import { formatNumber, getRawAmount } from "src/utils/parseStringToBigNumber"
import useFerroBoostHandlers from "../../hooks/useFerroBoostHandlers"
import { useAction } from "src/hooks/useAction"
import { actions } from "src/state/xFer"
import Text from "src/components/Text"
import { enqueueToast } from "src/components/Toastify"
import Modal from "src/components/Modal"
import { TransactionSummaryData } from "src/components/TransactionSummary"

interface WithdrawModalProps {
  stakeIds: number[]
}

const WithdrawModal: React.FC<WithdrawModalProps> = ({
  stakeIds,
}: WithdrawModalProps) => {
  const { t } = useTranslation()

  const { boostData } = useUserFerroBoost()
  const closeWithdrawModal = useAction(actions.setOpenedWithdrawModal, null)

  const { onBatchWithdraw } = useFerroBoostHandlers()

  const amount = getRawAmount(
    boostData.stakes
      .map((x, i) => (stakeIds.includes(i) ? x.amount : BIG_ZERO))
      .reduce((a, b) => a.add(b), BIG_ZERO),
    XFER.decimals,
  )

  const summary: TransactionSummaryData = [
    {
      label: t("Withdraw"),
      amount: formatNumber(amount, 2, 6),
      token: XFER,
    },
  ]

  const onConfirm = async () => {
    try {
      await onBatchWithdraw(stakeIds, summary)
    } catch (e: any) {
      console.error(e)
      enqueueToast(
        "error",
        t("xFER removal failed. Please retry later"),
        t("Withdraw Transaction failed"),
      )
    }
    closeWithdrawModal()
  }

  return (
    <Modal title={t("Confirm Withdrawal")} open onClose={closeWithdrawModal}>
      <Box>
        <Text mb={2}>{t("Withdraw amount")}</Text>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex">
            <Text>{formatNumber(amount, 2, 6)}</Text>
          </Box>
          <Box display="flex" alignItems="center">
            <Text mr="4px">{XFER.symbol}</Text>
            <img src={XFER.icon} />
          </Box>
        </Box>
        <Box
          maxWidth="468px"
          borderRadius="12px"
          bgcolor="#424B6E"
          p="18px"
          my={3}
        >
          <Text>
            {t(
              "You will stop earning the Vault FER rewards by removing your unlocked xFER.",
            )}
          </Text>
        </Box>
        <Button onClick={onConfirm} fullWidth>
          {t("Confirm Withdraw")}
        </Button>
      </Box>
    </Modal>
  )
}

export default WithdrawModal
